import { Anchor, H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React, { ReactElement } from 'react';
import styles from './BoxWithCta.module.scss';

interface BoxWithCtaProps {
  titleKey: string;
  content: ReactElement;
  buttons: ReactElement[];
  contentUrl?: string;
}

export const BoxWithCta = ({ titleKey, content, buttons, contentUrl }: BoxWithCtaProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.wrapper}>
      <H3 className={styles.title}>{t(titleKey)}</H3>
      <div className={styles.box}>
        {contentUrl ? (
          <Anchor className={styles.content} href={contentUrl} isBold target="">
            {content}
          </Anchor>
        ) : (
          <div className={styles.content}>{content}</div>
        )}
        <span className={styles.separator} />
        <div className={styles.buttons}>{buttons.map((button) => button)}</div>
      </div>
    </section>
  );
};
